import actionTypes from '../../actions/bill/refund/actionType';

const initialState = {
  refundSource: '', // 退款抽屉来源(partSettle: 部分结账，settle: 结账)
  refundDrawerVisible: false,
  refundInfoLoading: false,
  refundInfo: {
    roomRate: [], // 房费
    deposit: [], // 押金
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_REFUND_SOURCE:
      const { refundSource } = payload;
      return {
        ...state,
        refundSource,
      };
    case actionTypes.TOGGLE_REFUND_DRAWER_VISIBLE:
      const { refundDrawerVisible } = payload;
      return {
        ...state,
        refundDrawerVisible,
      };

    case actionTypes.SET_REFUND_INFO_LOADING:
      const { refundInfoLoading } = payload;
      return {
        ...state,
        refundInfoLoading,
      };
    case actionTypes.FETCH_REFUND_INFO:
      const { refundInfo } = payload;
      return {
        ...state,
        refundInfo,
      };
    case actionTypes.UPDATE_REFUND_INFO:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
